import { render, staticRenderFns } from "./MailboxMailBar.vue?vue&type=template&id=531ae218&scoped=true"
import script from "./MailboxMailBar.vue?vue&type=script&lang=js"
export * from "./MailboxMailBar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "531ae218",
  null
  
)

export default component.exports